<template>
    <div class="article-contact">
        <p>We'd love to hear about your project! Maybe we can help.</p>
    </div>
</template>

<script>
export default {
    name: 'ArticleContact',
};
</script>
